// @ts-nocheck
import React, { FC } from 'react';
import styled from 'styled-components';

import { Container, Row, Col } from 'crehana-ui/GridV2';
import PrimaryButton from 'crehana-ui/Buttons/PrimaryButton';

import Countdown from '../../components/Countdown';
import Background from './Background';
import { HeroSectionType } from '../../types';

const Section = styled.section`
  background: radial-gradient(
      65.38% 65.38% at 12.19% 5.1%,
      rgba(255, 178, 0, 0.3) 0%,
      rgba(7, 14, 39, 0) 90.33%
    ),
    radial-gradient(
      71.66% 72.21% at 89.06% 11.06%,
      rgba(242, 22, 115, 0.25) 0%,
      rgba(7, 14, 39, 0) 100%
    ),
    radial-gradient(
      143.98% 62.02% at 50% 0%,
      #3417aa 0%,
      rgba(7, 14, 39, 0) 100%
    ),
    radial-gradient(
      119.86% 119.86% at 50% -19.86%,
      rgba(7, 14, 39, 0) 23.77%,
      #070e27 100%
    ),
    #070e27;
  ${({ theme }) => theme.breakpoints.up('lg')} {
    background: unset;
    padding-top: 172px;
    padding-bottom: 76px;
  }
`;

interface HeroSectionProps extends HeroSectionType {
  handleClickOnPrimaryButton(): void;
  remainingOfferTime?: Date;
}

const HeroSection: FC<HeroSectionProps> = ({
  handleClickOnPrimaryButton,
  backgroundImage,
  title,
  subtitle,
  buttonLabel,
  remainingOfferTime,
}) => {
  return (
    <Section
      id="membershipv2-main-section"
      className="relative py-40 md:pt-120 md:pb-80 overflow-hidden"
    >
      <Background backgroundImage={backgroundImage} />
      <Container className="relative z-6 mt-56 md:mt-0">
        <Row className="flex flex-col items-center md:items-start">
          <Col xs={12} sm={10} md={6} lg={5}>
            <div className="flex flex-col items-center md:items-start ">
              <h1 className="font-h1 text-white text-left mb-24">{title}</h1>
              <p className="font-body3 text-gray-main mb-32">{subtitle}</p>
              <div className="w-full max-w-360 sm:max-w-280 mr-auto">
                <PrimaryButton
                  full
                  darkMode
                  size="l"
                  label={buttonLabel}
                  onClick={handleClickOnPrimaryButton}
                />
                {remainingOfferTime && (
                  <Countdown dueDate={remainingOfferTime} />
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Section>
  );
};

export default HeroSection;
